import PostEventCard from './PostEventCard';

export default PostEventCard;
